import { EliteLandingPageState, type EliteOnboardingStatusResponse } from '../../types/misc.types'

/** Plan selector omits state when expired so pricing chrome matches renewal UX. */
export function getPlanSelectorEliteLandingPageState(
  eliteLandingPageState?: EliteOnboardingStatusResponse['eliteLandingPageState']
): EliteOnboardingStatusResponse['eliteLandingPageState'] | undefined {
  if (eliteLandingPageState === EliteLandingPageState.PLAN_EXPIRED) {
    return undefined
  }
  return eliteLandingPageState
}
